'use strict';

var angular = require('angular');
var dependencies = ['AVRO.FaresOptimizer.AnalysisRecommendationGrids', 'AVRO.FaresOptimizer.AnalysisFilters'];
module.exports = angular.module('AVRO.FaresOptimizer.AnalysisPanel', dependencies).controller('FareOptimizerAnalysisPanelController', require('./controllers/FareOptimizerAnalysisPanelController')).directive('rmFaresOptimizerAnalysisPanel', require('./directives/FaresOptimizerAnalysisPanelDirective'));